import _concat from "lodash/concat";
import users from "./users";

export default {
  path: "/users",
  component: () => import("@/layouts/FullLayout"),
  children: _concat(users)
};
